import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { apiCreateEvent } from '../../services/api';

function getDefaultDateValue() {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 16);
}

export default function EventCreate() {
  const { token } = useAuth();
  const [formData, setFormData] = useState({
    title: '',
    eventDate: getDefaultDateValue(),
    location: '',
    theme: '',
    description: '',
    maxGuests: 50,
    backgroundImageUrl: '',
    isPublished: true,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [inviteLink, setInviteLink] = useState('');

  const qrCodeUrl = useMemo(() => {
    if (!inviteLink) return '';
    return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(inviteLink)}`;
  }, [inviteLink]);

  const onChange = (field) => (event) => {
    const value = field === 'isPublished' ? event.target.checked : event.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setInviteLink('');
    setLoading(true);

    try {
      const data = await apiCreateEvent(formData, token);

      if (data.error) {
        setError(data.error);
      } else {
        setSuccess(data.message || 'Evento criado com sucesso.');
        setInviteLink(data.inviteLink || '');
      }
    } catch (_error) {
      setError('Não foi possível criar o evento agora.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="festify-shell">
      <section className="festify-main">
        <header className="festify-page-header">
          <div>
            <p className="festify-eyebrow">Festify</p>
            <h1>Criar novo evento</h1>
            <p>Monte seu convite em minutos e compartilhe por link ou QR Code.</p>
          </div>
          <div className="festify-header-actions">
            <Link to="/" className="ghost-btn">Ir para dashboard</Link>
          </div>
        </header>

        <form className="festify-form-card" onSubmit={handleSubmit}>
          {error && <p className="api-error">{error}</p>}
          {success && <p className="api-success">{success}</p>}

          <div className="grid-two">
            <label>
              Título do evento
              <input required value={formData.title} onChange={onChange('title')} placeholder="Aniversário da Ana" />
            </label>
            <label>
              Data e hora
              <input required type="datetime-local" value={formData.eventDate} onChange={onChange('eventDate')} />
            </label>
          </div>

          <div className="grid-two">
            <label>
              Local
              <input required value={formData.location} onChange={onChange('location')} placeholder="Rua das Flores, 123" />
            </label>
            <label>
              Tema
              <input value={formData.theme} onChange={onChange('theme')} placeholder="Tropical Chic" />
            </label>
          </div>

          <div className="grid-two">
            <label>
              Máximo de convidados
              <input
                required
                type="number"
                min="1"
                value={formData.maxGuests}
                onChange={onChange('maxGuests')}
              />
            </label>
            <label>
              URL da imagem de fundo (opcional)
              <input
                value={formData.backgroundImageUrl}
                onChange={onChange('backgroundImageUrl')}
                placeholder="https://..."
              />
            </label>
          </div>

          <label>
            Descrição
            <textarea
              rows="4"
              value={formData.description}
              onChange={onChange('description')}
              placeholder="Mensagem de boas-vindas e instruções para os convidados"
            />
          </label>

          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={formData.isPublished}
              onChange={onChange('isPublished')}
            />
            Publicar alterações imediatamente
          </label>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Criando evento...' : 'Criar evento'}
          </button>
        </form>

        {inviteLink && (
          <section className="festify-form-card invite-result">
            <h2>Link do convite pronto</h2>
            <a href={inviteLink} target="_blank" rel="noreferrer" className="invite-link">{inviteLink}</a>
            <div className="qr-wrapper">
              {qrCodeUrl && <img src={qrCodeUrl} alt="QR Code do convite" />}
            </div>
          </section>
        )}
      </section>
    </main>
  );
}
